/**
 * Статус промпта
 */
export const enum PromptStatus {
    Moderation = 'moderation',
    Rejected = 'rejected',
    Published = 'published',
    Unpublished = 'unpublished',
    Postponed = 'postponed',
}

/**
 * Комментарий модерации
 */
export const enum ModerationComment {
    Later = 'later',
}

/**
 * Структура промпта из JSON файла
 */
export type Prompt = {
    id: number;
    title: string;
    description: string;
    categories: string[];
    categoriesEn: string[];
    prompt: string;
    promptImage?: string;
    promptForExample: string;
    example: string;
    exampleImage?: string;
    imageName: string;
    videoData: {
        url: string;
    };
    imageData: {
        url: string;
        urlOptimized: string;
        imagename: string;
        groupId: number;
        colors: Record<string, string>;
    };
    likes: number;
    visits: number;
    isLiked: boolean;
    status: PromptStatus;
    createdAt: string;
    moderationComment: ModerationComment | null;
    author:
        | {
              uid: string;
              login?: string;
              name?: string;
              image?: string;
              promptsCount?: number;
          }
        | null
        | undefined;
};

/**
 * Параметры для получения списка промптов с пагинацией
 */
export type PromptsParams = {
    cursor?: string;
    categories?: string[]; // Фильтр по категориям (проверяется вхождение всех в массив categoriesEn)
    limit?: number;
    hash?: string; // Хэш для рандомной, но стабильной сортировки
};

/**
 * Ответ API со списком промптов и курсором
 */
export type PromptsResponse = {
    prompts: Prompt[];
    next_cursor: string | null;
};

/**
 * DTO для создания промпта
 * Используем поля из типа Prompt + author
 */
export type CreatePromptDto = Pick<Prompt, 'title' | 'description' | 'prompt' | 'categories'> & {
    author: string; // Логин автора
};

/**
 * DTO для обновления промпта (оставляем как мок)
 */
export type UpdatePromptDto = {
    title?: string;
    description?: string;
    content?: string;
    category?: string;
    status?: 'draft' | 'published' | 'archived';
};
